import common from "../common";
import Scene from "./Scene";

export default class PreloaderScene extends Scene {
    constructor()
    {
        super();

        this.loaded = 0;
        this.loadedVisual = 0;
    }

    init()
    {
        super.init();
        
        var barOuter = common.display.sprite({asset:"preloader_overlay", anchor:0.5, x:(common.STAGE_WIDTH / 2) - 250, y:(common.STAGE_HEIGHT / 2) + 20, parent:this})
    
        this._barInner = common.display.sprite({asset:"preloader_fill", x: barOuter.x - (barOuter.width/2) - 170, y: barOuter.y - (barOuter.height/2) + 10, parent:this});
        
        this.addChild(barOuter);
    
        this._barInnerStartX = this._barInner.x;
        
        var black = new PIXI.Sprite(common.display.colourTextures.black);
        black.x = this._barInner.x - (this._barInner.width/2);
        black.width = barOuter.width/2;
        black.height = common.STAGE_HEIGHT;
        this.addChild(black);

    }

    destroy()
    {
        super.destroy();
    }

    exit()
    {

    }

    update()
    {
        
        this.loadedVisual += (this.loaded - this.loadedVisual) * 0.2;

        console.log(this.loadedVisual);
        this._barInner.x = this._barInnerStartX + (698 * this.loadedVisual);

        super.update();   
    }
}